import React from 'react';

function RenderError({ error }) {
  if (!error) {
    return false;
  }

  return (
    <small className="form__help u--color-red u--margin-top-10">
      <span className="form__help-icon icon icon--md perc-icon-caret-right"></span>
      {error}
    </small>
  );
}

export default RenderError;
